import { LanguageEnum } from 'gleblu-socket-api';
import { createReducer } from 'redux-act';

import { getBrowserLanguage } from '../../localization/languages/languages';
import { languageLocaleChanged, LanguageLocaleChangedPayload } from '../actions/language/languageLocaleChanged';

export interface LanguageState {
  selectedLanguage: LanguageEnum;
}

const defaultState: LanguageState = {
  selectedLanguage: getBrowserLanguage() || LanguageEnum.ENGLISH,
};

const languageReducer = createReducer<LanguageState>({}, defaultState);

languageReducer.on(languageLocaleChanged, (prevState, { languageEnum }: LanguageLocaleChangedPayload) => ({
  ...prevState,
  selectedLanguage: languageEnum,
}));

export default languageReducer;
